import styled from '@emotion/styled';

export const ProgressContainer = styled.div`
    height: ${p => p.height ? p.height+'px' : '20px'};
    width: 100%;
    backgroundColor: #e0e0de;
    borderRadius: 50;
    margin: 50;
`
export const ProgressFilterSytle = styled.div`
    height: 100%;
    width: ${p => p.completed? p.completed:0}%;
    background-color: ${p => p.bgcolor? p.bgcolor:'gray'};
    background: linear-gradient(to right, ${p=>p.bgcolor} 0%, ${p=>p.bgcolor} 95%, #fff 95%, #fff 100%);
    borderRadius: inherit;
    textAlign: right;
    display:inline-block;
`
export const LabelStyle = styled.span`
    padding: 10px;
    color: white;
    fontWeight: bold
`